.Sparkles {
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 1000;
}

.sparkle {
    position: absolute;
    top: var(--sparkle-top);
    left: var(--sparkle-left);
    width: var(--sparkle-size);
    height: var(--sparkle-size);
    color: var(--sparkle-color);
    animation: sparkle-burst var(--sparkle-duration) ease-out var(--sparkle-delay) forwards;
    opacity: 0;
}

.sparkleSvg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 4px currentColor);
}

@keyframes sparkle-burst {
    0% {
        transform: scale(0) rotate(0deg);
        opacity: 0;
    }
    20% {
        transform: scale(1.2) rotate(30deg);
        opacity: 1;
    }
    50% {
        transform: scale(1) rotate(60deg);
        opacity: 1;
    }
    100% {
        transform: scale(0) rotate(180deg);
        opacity: 0;
    }
}
